export default __webpack_public_path__ + "static/media/award.b4716368.svg";